import React from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { styled } from '@mui/material'
import { MobileMenuIcon } from '../../eid-icons'

const StyledMobileMenuIcon = styled(MobileMenuIcon)(({ theme }) => ({
    position: 'fixed',
    top: '43vh',
    left: 0,
    cursor: 'pointer',
    zIndex: 25,
}))

const MobileMenuButton = ({ classes, onClick, className }) => {
    const { t } = useTranslation()

    return (
        <StyledMobileMenuIcon
            color="#000000"
            onClick={onClick}
            aria-label={t('Common_Menu')}
            className={clsx(classes.mobileMenuButton, className)}
        />
    )
}

MobileMenuButton.propTypes = {
    onClick: PropTypes.func,
}

export default MobileMenuButton
